import { createFileRoute } from '@tanstack/react-router'

import { PassCardBindError } from '@/pages/pass-card-bind-error'

export const Route = createFileRoute('/_protected/pass-card-bind/error')({
    component: () => <PassCardBindError />,
    validateSearch: (search) => {
        return {
            error: search.error ? String(search.error) : undefined,
        }
    },
})
